// A safe wrapper around sessionStorage that catches errors when storage is disabled
export const safeSessionStorage = {
  getItem: (key: string) => {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },

  setItem: (key: string, value: string) => {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      throw new Error(
        "Your browser’s privacy settings are blocking storage. To continue, allow site storage or exit private browsing."
      );
    }
  },

  removeItem: (key: string) => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};
